import React from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { useAuth, useCurrentUrl } from './hooks'
import { ContentBackdrop } from './components'

type Props = {
  children: React.ReactNode;
};

export const PrivateRoute: React.FC<Props> = ({
  children
}): JSX.Element | null => {
  const { user, loading } = useAuth()
  const navigate = useNavigate()
  const location = useLocation()
  const { setCurrentUrl } = useCurrentUrl()

  // navigate() や setCurrentUrl() は副作用のため、render 中ではなく useEffect 内で実行する。
  // また、/auth/login がカレント URL の場合に認証処理がループするのを回避する。
  React.useEffect(() => {
    if (location.pathname.match(/\/auth/g)) return

    // カレントURLを保存
    setCurrentUrl(location.pathname)

    // ユーザー情報がない場合は再認証させる。
    // URL直打ちの場合はsessionStorageにURLを保存して再認証後にリダイレクトする。
    if (!loading && !user) {
      navigate('/auth/login', { replace: true })
    }
  }, [location.pathname, setCurrentUrl, loading, user, navigate])

  if (loading) {
    return <ContentBackdrop />
  }

  // 未認証の場合は保護対象ページが一瞬でも描画されないよう、何も描画しない。
  if (!user) {
    return null
  }

  return <>{children}</>
}
